import type { CheckboxField as CheckboxFieldSchema } from "shared"
import { Checkbox } from "@rawa/ui/Checkbox"
import styles from "./CheckboxField.module.scss"

type Props = {
  field: CheckboxFieldSchema
  value: boolean
  onChange: (value: boolean) => void
}

export function CheckboxField({ field, value, onChange }: Props) {
  return (
    <Checkbox
      className={styles.checkboxField}
      checked={value}
      label={field.label}
      onChange={onChange}
    />
  )
}
